import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../config/api';

export const fetchSEO = createAsyncThunk(
  'seo/fetchSEO',
  async (page, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/api/public/seo/${page}`);
      return { page, data: response.data.data };
    } catch (error) {
      // Return null if SEO not found (use defaults)
      return { page, data: null };
    }
  }
);

const seoSlice = createSlice({
  name: 'seo',
  initialState: {
    settings: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSEO.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSEO.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.data) {
          state.settings[action.payload.page] = action.payload.data;
        }
      })
      .addCase(fetchSEO.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default seoSlice.reducer;

